import { v4 as uuidv4 } from 'uuid';

export const generateGuid = () => uuidv4()

export const isGuid = (value: string): boolean => {
    const guidRegex = /^[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}$/;
    return guidRegex.test(value);
}